import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import image from '../../../assets/images/whiky_house/-NYxTxbMew2iGaQCmrZF'
import "./card_slide.css";
import {
  AiOutlineArrowLeft,
  AiOutlineArrowRight,
  AiOutlineShoppingCart,
} from "react-icons/ai";

const NextArrow = ({ onClick }) => {
  return (
    <div
      onClick={onClick}
      className="absolute cursor-pointer lg:-right-10 shadow-md bg-white p-4 rounded-full md:right-4 top-[47%]">
      <AiOutlineArrowRight />
    </div>
  );
};
const PrevArrow = ({ onClick }) => {
  return (
    <div
      onClick={onClick}
      className="absolute cursor-pointer lg:-left-10 shadow-md bg-white p-4 rounded-full md:-left-10 left-3 z-50 top-[47%] ">
      <AiOutlineArrowLeft />
    </div>
  );
};

const CardSlide = ({SlideData,title}) => {

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    initialSlide: 0,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          arrows: false,
          centerMode: true,
          infinite: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          centerMode: true,
          infinite: true,
        },
      },
    ],
  };

  return (
    <>
      <div className="">
        <h1 className=" text-center mb-6 text-[22.5px] px-10 titlefont font-medium ">
        {title}
        </h1>
      </div>
      <div className="px-8">
      <Slider {...settings}>
        {SlideData?.map((item) => (
          <div className=" w-full rounded-lg  md:max-w-[16rem] h-96 p-4 mt-1 relative" key={item.id}>
            <div floated={false} className=" h-96  rounded-none flex-col flex  items-center">
              <div className="min-h-[12rem] max-h-[13rem]">
              <img
                src={item.img}
                alt="profile-picture"
                className=" min-h-48 w-full  object-contain"
              />
             </div>
            <div className="text-start max-h-32 pl-1">
                <div className="h-20">
                <div color="blue" className=" hover:text-[#7e6553] transition-all text-xs tracking-wide leading-5  text-[15px] mt-2 titlefont" textGradient>
                {item.name.slice(0,40)}
                </div>
              <div variant="" color="blue-gray" className="textfont mt-4 text-sm text-[#7e6553]">
                {item.price} MMK
              </div>
            </div>
                <div className="px-2 mt-2 text-font text-[14px]">
                  {item.label}
                </div>
                <div className=" mt-auto ">
                <button
              class="self-start  btn2 border-[#d9cec2] w-full  py-3 relative text-[14px] border e uppercase font-semibold tracking-wider leading-none overflow-hidden hover:text-[#7e6553]"
              type="button">
              <span class="absolute inset-0 bg-[#d9cec2]"></span>
              <span class="absolute inset-0 flex justify-center items-center text-[14px] font-bold">
                View Details
              </span>
              View Details
            </button>
               </div>
            </div>
            </div>
          </div>
        ))}
      </Slider>
    
      </div>
    </>
  );
};

export default CardSlide;
